import dayjs from 'dayjs';

// A 'date' field's DatePicker onChange gives a dayjs holding local midnight
// for the picked day. Serializing that raw (e.g. via JSON.stringify, which
// calls dayjs's .toJSON() -> .toISOString()) shifts it to UTC and can land
// on the previous/next calendar day depending on the visitor's timezone.
// This field has no time component, so submit a plain 'YYYY-MM-DD' string
// instead — it carries no timezone to shift against.
export const serializeDateFieldValue = (value) => (value ? dayjs(value).format('YYYY-MM-DD') : null);
